import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[appAwCardHeader]',
})
export class CardHeaderDirective {
    template = inject<TemplateRef<any>>(TemplateRef);
}
